import RootModel from './root';

const WorkflowResult = new RootModel({
	path: 'workflowresults',
});

export default WorkflowResult;
